import React, {useMemo} from 'react'
import ReactDOM from 'react-dom'
import {useAppSelector} from 'store'
import {getDomContainer} from 'src/lib/getDomContainer'
import {getModal} from 'store/modal/selectors'
import {WinModal} from '../WinModal'
import {LoseModal} from '../LoseModal'
import {CongratulateModal} from '../CongratulateModal'
import {LoaderModal} from '../LoaderModal'
import {HintModal} from '../RiddlesAdmin/HintModal/HintModal'
import {YesNoModal} from '../RiddlesAdmin/YesNoModal/YesNoModal'
import { TopCupModal } from '../TopCupModal'

const modalContainer = getDomContainer('modal')

export const ModalContainer = () => {
  const modal = useAppSelector(getModal())

  const component = useMemo(() => {
    switch(modal.type) {
      case 'Hint': return <HintModal {...modal.props} />
      case 'Win': return <WinModal {...modal.props} />
      case 'Lose': return <LoseModal {...modal.props} />
      case 'Loader': return <LoaderModal {...modal.props} />
      case 'Congratulate': return <CongratulateModal {...modal.props} />
      case 'YesNo': return <YesNoModal {...modal.props} />
      case 'TopCup': return <TopCupModal {...modal.props} />
    }
  }, [modal.type])

  if (modal.type === 'None') {
    return null
  }

  return ReactDOM.createPortal(component, modalContainer)
}
